import { UserResponse } from 'src/app/web-api-client';

export class User {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  fullName: string;
  isActive: boolean;
  isExternal: boolean;
  initials: string;

  constructor(userResponse: UserResponse) {
    if (!userResponse.id) console.error('"id" property is required.');
    this.id = userResponse.id!;
    this.email = userResponse.email!;
    this.firstName = userResponse.firstName!;
    this.lastName = userResponse.lastName!;
    this.fullName = `${userResponse.firstName} ${userResponse.lastName}`;
    this.isActive = userResponse.isActive!;
    this.isExternal = userResponse.isExternal!;
    this.initials = `${userResponse.firstName![0]}${userResponse.lastName![0]}`;
  }
}
